// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__e0KDo","noMarginUp":"Divider_noMarginUp__3kY-C","noMarginDown":"Divider_noMarginDown__3uCpV"};